import apiClient from "./apiClient";

export const updateStatusForTimeline = async (
  stepId,
  step,
  subStep,
  status
) => {
  try {
    const response = await apiClient.post("/audit/audit-history", {
      step_id: stepId,
      step: step,
      sub_step: subStep,
      status: status,
    });
    return response.data;
  } catch (error) {
    console.error("Error while updating the user timeline", error);
    throw error;
  }
};

export const fetchStatusOfTimeline = async () => {
  try {
    const response = await apiClient.get("/audit/audit-history");
    return response.data;
  } catch (error) {
    console.error("Error fetching user timeline", error);
    throw error;
  }
};
